<div id="dept-psychology" class="inner-page">
  <div class="container-fluid px-lg-5">

    <h2 class="title">Department of Psychology</h2>
    <p class="inner-lead mt-3">
      The Department of Psychology at Shah Satnam Ji Girls' College, Sirsa offers an in-depth study of human behaviour, mental processes and psychological theories. The department is equipped with a Psychology Lab for practical work and research activities.
    </p>

    <hr class="divider">

    <h4 class="section-subtitle">Courses Offered</h4>
    <ul class="inner-lead">
      <li>Psychology as a subject in BA</li>
    </ul>

    <hr class="divider">

    <h4 class="section-subtitle">Faculty</h4>
    <div class="table-responsive-inner mt-3">
      <table class="inner-table">
        <thead>
          <tr>
            <th>Sr. No.</th>
            <th>Name</th>
            <th>Qualification</th>
          </tr>
        </thead>
        <tbody>
          <tr><td>1</td><td>Ms. Shaina Rani</td><td>M.Sc. Psychology, UGC-NET, PG Diploma in Guidance & Counselling.</td></tr>
          <tr><td>2</td><td>Ms. Meena Rani</td><td>MA Psychology, B.Ed, Diploma in Counselling.</td></tr>
        </tbody>
      </table>
    </div>

    <hr class="divider">

    <h4 class="section-subtitle">Department Activities</h4>
    <ul class="inner-lead">
      <li>Mental Health Day Awareness Programme</li>
      <li>Guest Lecture on Anxiety Control</li>
      <li>Stress Management Seminar</li>
    </ul>

  </div>
</div>
